<template>
  <div class="content">
    <table class="table">
      <thead>
        <tr>
          <th class="head" colspan="2">
            {{ this.user.country }} OTT Platforms
          </th>
        </tr>
        <tr class="headline-2">
          <th>Streaming service</th>
          <th>Price*</th>
        </tr>
      </thead>
      <tbody class="body">
        <template v-for="(item, j) in items">
          <tr class="row-table" :key="item.platform">
            <td :class="{ claro: j % 2 == 0, oscuro: j % 2 == 1 }" class="text">
              {{ item.platform | uppercase }}
            </td>
            <td
              :class="{
                claro: j % 2 == 0,
                oscuro: j % 2 == 1,
                green: item.price == 'Free',
              }"
              class="value"
            >
              {{ item.price }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div style="margin-top: 50px" v-if="banner != []">
      <ith-sad-asside :items="banner" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    items: [],
    banner: [],
  }),
  created() {
    this.getInfo();
    this.getBanner();
  },

  computed: mapState(["user", "banners"]),
  watch: {
    banners() {
      if (this.banners) this.getBanner();
    },
    "user.country": function () {
      this.getInfo();
    },
  },
  methods: {
    getBanner() {
      if (this.banners)
        this.banners.forEach((el) => {
          if (el.page == "articles" && el.position == "right")
            this.banner.push(el);
        });
      this.banner.sort(function (a, b) {
        if (a.order < b.order) {
          return -1;
        }
        if (a.order > b.order) {
          return 1;
        }
        return 0;
      });
    },
    getInfo() {
      let params = { country: "USA" };
      if (this.user.country) params = { country: this.user.country };

      this.$Parse.Cloud.run("getSubscriptionPrices", params)
        .then((res) => {
          this.items = res;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.table {
  border-collapse: collapse;
}
.head {
  border-radius: 5px 5px 0 0;
}
.table > tbody > tr:last-child > td {
  border-radius: 0 0 0px 5px;
}
.table > tbody > tr:last-child > td:last-child {
  border-radius: 0 0 5px 0px;
}
.head {
  background-color: #ff5f5f;
  font-weight: 800;
  text-align: center;
  font-size: 1.2em;
  padding: 7px 0;
}

.headline-2 {
  font-size: 0.9rem;
  background-color: #1c2531;
  height: 40px;
}
.body > tr > td {
  height: 35px;
  width: 50%;
  font-size: 0.7rem;
  text-align: center;
  border-top: 1px solid #738092;
}
.title {
  text-align: center;
  font-weight: 600;
  border: 1px solid #738092;
  padding-top: 13px;
}

.value {
  border-left: 1px solid #738092;
  color: #cacaca;
}
.row-table:hover .value {
  color: white;
  font-weight: bold;
}
.row-table:hover .text {
  color: #94c659;
  font-weight: bold;
}

.green {
  font-weight: bold;
  color: #94c659 !important;
}
.claro {
  background-color: #375072;
}
.oscuro {
  background-color: #284060;
}

.divider {
  height: 60px;
}

@media (min-width: 1264px) and (max-width: 1400px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.8em;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.7em;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.7em;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .content {
    display: grid;
    grid-template-columns: 48% 4% 48%;
  }
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.6em;
  }
}

@media (max-width: 600px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.5em;
  }
}
</style>
